import React from 'react';
import { observer, Provider } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';

import { SubPageTextIndicator } from 'legacyComponents/indicators';
import DocumentHead from 'legacyComponents/documentHead';
import { SubPageStats } from 'legacyComponents/layout/subPageStats';
import {
  MainWrapper,
  IssueWrapper,
  CrumbsWrapper,
} from 'legacyComponents/styled/lib';
import { FourOhFour } from 'apps/fourOhFour/index';
import { DirLink, DirName } from 'apps/repository/styles';
import { clientStore } from 'apps/client/app';
import { mapToObject } from 'apps/utils';
import { imageSrc } from 'apps/file/utils';
import { conf as globalConf } from 'apps/config.yaml';

import { IssuePageAppManager } from 'apps/issueTracker/issuePage/appManager';
import { IssuePageContent } from 'apps/issueTracker/views/issuePageContent';
import { IssuePageStats } from 'apps/issueTracker/views/issuePageStats';

@withNamespaces()
@observer
export class IssuePage extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new IssuePageAppManager(null, this.props);
  }

  render() {
    const projectRoute = `${clientStore.spaceRoute.route}`;
    const { params } = this.props;

    const manager = this.appManager;
    if (manager.queries.get('issuePage')?.notFound) {
      return <FourOhFour type='Issue Page' />;
    }

    const routeParams = mapToObject(params);
    const projectRouteParams = Object.assign({}, routeParams);

    const { issuePage } = manager;
    if (issuePage === null && manager.loading) {
      return (
        <MainWrapper>
          <CrumbsWrapper>
            <DirLink
              name={`${projectRoute}.issues`}
              params={projectRouteParams}
              first
            >
              All Tasks
            </DirLink>
            <DirName>&nbsp;/&nbsp;</DirName>
            <DirName>...</DirName>
          </CrumbsWrapper>
          <IssueWrapper>
            <SubPageTextIndicator />
            <SubPageStats loading />
          </IssueWrapper>
        </MainWrapper>
      );
    }

    return (
      <Provider issueTrackerManager={this.appManager}>
        <DocumentHead
          title={`${issuePage?.title} – ${issuePage?.inSpace.content.title}`}
          description={issuePage?.description}
          imagePath={imageSrc(
            issuePage?.inSpace.content.avatar,
            '',
            globalConf.imgSizes.project.large,
          )}
        />
        <MainWrapper>
          <CrumbsWrapper>
            <DirLink
              name={`${projectRoute}.issues`}
              params={projectRouteParams}
              first
            >
              All Tasks
            </DirLink>
            <DirName>&nbsp;/&nbsp;</DirName>
            <DirName>{`#${issuePage?.number}`}</DirName>
          </CrumbsWrapper>
          <IssueWrapper>
            <IssuePageContent />
            <IssuePageStats />
          </IssueWrapper>
        </MainWrapper>
      </Provider>
    );
  }
}

IssuePage.propTypes = {
  params: PropTypes.object,
  id: PropTypes.number,
  t: PropTypes.func,
};
